import { IAppointmentSlot } from '@sondermind/data-access/public-facing/provider-calendar';

/**
 * Counts distinct calendar days across a slot list, matching the day grouping
 * `AppointmentCarouselComponent.processAppointmentSlots` uses to build carousel columns — so a
 * consumer that needs a day count without rendering the carousel (e.g. the calendar-initialized
 * analytics event, which must reflect total availability regardless of the session-format filter)
 * gets the same number the carousel would show.
 */
export function countUniqueCalendarDays(slots: IAppointmentSlot[]): number {
  const uniqueDayKeys = new Set(
    slots.map((slot) => {
      const date = slot.utcStartTime;
      return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
    })
  );

  return uniqueDayKeys.size;
}
